export default __webpack_public_path__ + "static/media/bg_voice_to_voice.c0fbf189.png";